import { requestWithToken } from '../../utilities/request';
const path = '/api/private/fields';

/**
 * 現場入退場設定情報取得API
 * @param {string} fieldId 現場ID
 * */
const fetchCheckInOutSettings = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/check_in_out_settings/`),
  });
};

/**
 * 顔認証機器登録確認API
 * @param {string} fieldId 現場ID
 * @param {string} integrationServiceId 連携サービスID
 * */
const fetchRegisterStatusMonitoring = (fieldId, integrationServiceId) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldId}/check_face_image_uses/${integrationServiceId}`
    ),
  });
};

/**
 * 現場入退場設定情報更新API
 * @param {string} fieldId 現場ID
 * @param {number} id 現場入退場設定ID
 * @param {object} param リクエストパラメーター
 * */
const updateCheckInOutSettings = (fieldId, id, param) => {
  return requestWithToken(
    {
      method: 'PATCH',
      url: path.concat(`/${fieldId}/check_in_out_settings/${id}`),
      data: param,
    },
    true,
    false
  );
};

export const FieldSettingsApi = {
  fetchCheckInOutSettings,
  fetchRegisterStatusMonitoring,
  updateCheckInOutSettings,
};

export default FieldSettingsApi;



// WEBPACK FOOTER //
// ./src/services/fieldSettings/FieldSettingsApi.js